import { render, staticRenderFns } from "./Regeneration.vue?vue&type=template&id=c345f97e&scoped=true&"
import script from "./Regeneration.vue?vue&type=script&lang=js&"
export * from "./Regeneration.vue?vue&type=script&lang=js&"
import style0 from "./Regeneration.vue?vue&type=style&index=0&id=c345f97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c345f97e",
  null
  
)

export default component.exports